<template>
    <div class="all">
        <!-- 预警信息列表 -->
        <div class="warp h-auto">
            <div class="warp-body">
                <h2 class="title">指定信源</h2>
                <div class="firle mt10 clearfix">
                    <div class="corm fl clearfix">
                        <span class="element cp" :class="{curr:type === 'follow'}" @click="getList('follow');">重点关注信源设置</span>
                        <span class="element cp" :class="{curr:type === 'exclude'}" @click="getList('exclude');">排除信源设置</span>
                    </div>
                </div>
                <div class="firle mt10 clearfix">
                    <div class="fl clearfix">
						<button class="btn btn-blue" @click="openSource();">新增</button>
						<button class="btn btn-blue" @click="delSource();">全部删除</button>
                    </div>
                    <div class="fr">
                        <span class="tion clearfix">
                            <div class="search-warp clearfix">
                                <span class="drop-down mores fl">
                                    <button class="btn search-dropdown"><span class="texts">{{MediaPlatformList[key]}}</span><i class="icons"></i></button>
                                    <ul class="option">
                                        <li v-for="(item,index) in MediaPlatformList" :key="index" @click="selectMedia(index,0);">{{item}}</li>
                                    </ul>
                                </span>
                                <button class="search-btn fr"><i class="icons search-icon"></i></button> 
                                <div class="hidden"><input type="text" v-model.trim="keyword" @input="KeyUpEsc" placeholder="输入信源名称搜索" class="input-text"></div>
                            </div>
                        </span>
                    </div>
                </div>
                <table class="table mt20 border" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="10%">
                        <col width="30%">
                        <col width="15%">
                        <col width="40%">
                        <col width="10%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>序号</th>
                            <th>信源名称</th>
                            <th>平台</th>
                            <th>网址</th>
                            <th class="ar">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in list" :key="index">
                            <td>{{index+1}}</td>
                            <td><a class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.source}}</a></td>
                            <td>{{item.platformName}}</td>
                            <td><a class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.domain}}</a></td>
                            <td class="ar">
                                <div class="table-all-icons move-bian">
                                    <a title="删除" @click="delSource(item.id,index)" href="javascript:void(0);" class="icons del-sm-icon"></a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
            </div>
        </div>
        <!-- 添加信源 -->
        <Dialog ref="sourceModal" width="600" :modalFoot="false" title="添加信源设置">
            <div slot="mdBox">
                <div class="clearfix">
                    <div class="search-warp clearfix">
                        <span class="drop-down mores fl">
                            <button class="btn search-dropdown"><span class="texts">{{MediaPlatformList[keys]}}</span><i class="icons"></i></button>
                            <ul class="option">
                                <li v-for="(item,index) in MediaPlatformList" :key="index" @click="selectMedia(index,1)" v-if="item != '全部'">{{item}}</li>
                            </ul>
                        </span>
                        <button class="search-btn btn-blue fr cp" type="button" @click="searchSource">搜索</button> 
                        <div class="hidden"><input type="text" v-model.trim="keywords" @keyup.enter="searchSource" placeholder="输入信源名称搜索" class="input-text"></div>
                    </div>
                </div>
                <div class="table-father maxH420">
                    <table v-if="lists != ''" class="table mt20 border" width="100%" border="0" cellpadding="0" cellspacing="0">
                        <colgroup>
                            <col width="30%">
                            <col width="20%">
                            <col width="40%">
                            <col width="15%">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>信源名称</th>
                                <th>平台</th>
                                <th>网址</th>
                                <th class="ar">操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in lists" :key="index">
                                <td><a class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.source}}</a></td>
                                <td>{{item.platformName}}</td>
                                <td><a class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.domain}}</a></td>
                                <td class="ar">
                                    <div class="table-all-icons move-bian">
                                        <!-- <a title="修改" v-if="tabType != 'wx'" href="javascript:void(0);" @click="editContacts(index);" class="icons edit-icon1"></a> -->
                                        <a class="color-blue" href="javascript:void(0);" v-if="item.isExist === 0" @click="addSource(index);">添加</a>
                                        <a class="color-red" v-if="item.isExist === 1">已添加</a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="no-data" v-if="nodatas"><span class="text">没有数据哦...</span></div>
                </div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
export default {
    components:{Dialog},
    data() {
        return {
            planId:'',//方案ID
            keyword:'',//关键词
            type:'',
            MediaPlatformList:'',//平台列表
            initialList:'',//页面初始展示列表
            list:'',//页面展示列表
            nodata:false,//显示暂无数据
            nodatas:false,//弹框显示暂无数据
            keywords:'',//弹框搜索关键词
            key:'',//搜索的类别
            keys:'',//弹框搜索的类别
            lists:'',//添加信源搜索的列表
        }
    },
    mounted() {
        let that = this;
        that.getMediaPlatform();
        // this.$confirm('是否登录?').then(() => {
        //     //点登录
        // })
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        // 获取指定信源数据
        getList (type){
            let that = this;
            that.type = type;
            that.key = 'total';
            that.$api.get('monitor/info-source/list',{sid:that.planId,type:type},r =>{
                that.$parent.showLoad = false;
                that.initialList = r.data;
                that.conditionScreen();
            })
        },
        // 获取媒体类型
        getMediaPlatform () {
            let that = this;
            that.platformType = [];
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/analysis/all-platform', null, r => {
                that.$utils.returnCode(r,function(){
                    that.MediaPlatformList = r.data;
                    that.getList('follow');
                });
            })
        },
        // 选择平台
        selectMedia (index,type){
            if(type === 0){//页面展示类别
                this.key = index;
                this.conditionScreen();
            }else{//弹框类别
                this.keys = index;
            }
        },
        KeyUpEsc (){
            this.conditionScreen();
        },
        // 条件筛选
        conditionScreen (){
            let list = this.initialList;
			let result;
			if(this.key === 'total'){
				result = list.filter(item => {
				    return item.source.indexOf(this.keyword) != -1
				})
			}else{
				result = list.filter(item => {
				    return item.platform === this.key && item.source.indexOf(this.keyword) != -1
				})
			}
            this.list = result;
            if(this.list == ''){
                this.nodata = true;
            }else{
                this.nodata = false;
            }
        },
        // 打开信源设置
        openSource (){
            this.keys = 'web';
			this.keywords = '';
			this.lists = '';
			this.nodatas = false;
            this.$refs.sourceModal.showMaskFun();
        },
        // 弹框搜索信源
        searchSource (){
            let that = this;
            that.platformType = [];
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/info-source/search', {sid:that.planId,type:that.type,platform:that.keys,source:that.keywords}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.lists = '';
                    if(r.data == ''){
                        that.nodatas = true;
                    }else{
                        that.nodatas = false;
                        that.lists = r.data;
                    }
                });
            })
        },
        // 添加信源
        addSource (index){
            let that = this;
            let list = that.lists[index];
            let data1 = {
                sid:that.planId,
                type:that.type,
            }
            let data = Object.assign(data1,list);
			that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('monitor/info-source/add', {data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.lists[index].isExist = 1;
                    that.initialList.push(r.data);
                    that.conditionScreen();
                });
            })
        },
        delSource (id,index){
            let that = this;
            let ids = [];
            let text = '是否确认删除此条信源？';
            if(id){
                ids.push(id)
            }else{
                let list = that.list;
                ids = list.map(v=>v.id);
                text = '是否删除所有信源？'
            }
            that.$confirm(text).then(() => {
                that.$api.get('monitor/info-source/del', {sid:that.planId,type:that.type,ids:ids}, r => {
                    that.$parent.showLoad = false;
                    that.$utils.returnCode(r,function(){
                        // that.list.splice(index,1);
                        for(let i of ids){
                            that.initialList.splice(that.initialList.findIndex(item => item.id === i), 1);
                        }
                        that.conditionScreen();
                        if(that.list.length <= 0){
                            that.nodata = true;
                        }
                        that.$utils.alertText('删除成功');
                    });
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/sourceCenter.vue